import { useFormContext } from 'react-hook-form';
import { t } from '@/lib/i18n';
import type { AddWizardValues } from '../../schemas';
import styles from './StepType.module.css';

export function StepType() {
  const { watch, setValue } = useFormContext<AddWizardValues>();
  const kind = watch('memberKind');

  return (
    <section data-testid="step-type">
      <div className={styles.header}>
        <div className={styles.stepLabel}>{t('STEP 1')}</div>
        <h1 className={styles.title}>{t('Who are you adding?')}</h1>
        <p className={styles.subtitle}>
          {t(
            'Linqage manages AI Members today. Human hiring through the same workflow is on the way.',
          )}
        </p>
      </div>

      <div className={styles.cards}>
        <label
          className={[styles.card, kind === 'ai' ? styles.cardChecked : '']
            .filter(Boolean)
            .join(' ')}
        >
          <input
            type="radio"
            className={styles.radio}
            name="hireKind"
            value="ai"
            checked={kind === 'ai'}
            onChange={() => setValue('memberKind', 'ai', { shouldValidate: true })}
          />
          <div className={styles.cardHead}>
            <div className={styles.cardIcon} aria-hidden="true">
              ✨
            </div>
            <span className={styles.pillAvailable}>● {t('Available now')}</span>
          </div>
          <div className={styles.cardName}>{t('AI Member')}</div>
          <p className={styles.cardDesc}>
            {t(
              'Add an AI Member to own a position on your team. Briefs in plain English, works in minutes, never sleeps.',
            )}
          </p>
          <ul className={styles.bullets}>
            <li>{t('Onboards in under 5 minutes')}</li>
            <li>{t('Tireless — runs jobs around the clock')}</li>
            <li>{t('Scales with usage, not headcount')}</li>
          </ul>
        </label>

        <label
          className={[styles.card, kind === 'human' ? styles.cardChecked : '']
            .filter(Boolean)
            .join(' ')}
        >
          <input
            type="radio"
            className={styles.radio}
            name="hireKind"
            value="human"
            checked={kind === 'human'}
            onChange={() => setValue('memberKind', 'human', { shouldValidate: true })}
          />
          <div className={styles.cardHead}>
            <div className={styles.cardIcon} aria-hidden="true">
              👥
            </div>
            <span className={styles.pillComing}>{t('Coming soon')}</span>
          </div>
          <div className={styles.cardName}>{t('Human')}</div>
          <p className={styles.cardDesc}>
            {t(
              'Source vetted contractors and full-time hires through Linqage. Same brief, same workflow — different talent pool.',
            )}
          </p>
          <ul className={styles.bullets}>
            <li>{t('Vetted talent network')}</li>
            <li>{t('Same brief, fed to recruiters')}</li>
            <li>{t('Manage humans alongside AI')}</li>
          </ul>
        </label>
      </div>
    </section>
  );
}
